import React from 'react';
import { clsx } from 'clsx';
import {
  TrendingUp,
  TrendingDown,
  Minus,
  FileText,
  PieChart,
  Clock,
  IndianRupee,
  AlertTriangle,
  AlertCircle,
  Building2,
  Wrench,
  Search,
  CheckCircle2,
} from 'lucide-react';
import { KPIMetric } from '../../types/dashboard';

interface KPICardProps {
  metric: KPIMetric;
  className?: string;
}

const ICON_MAP: Record<string, React.ReactNode> = {
  FileText: <FileText className="w-5 h-5" />,
  PieChart: <PieChart className="w-5 h-5" />,
  Clock: <Clock className="w-5 h-5" />,
  IndianRupee: <IndianRupee className="w-5 h-5" />,
  AlertTriangle: <AlertTriangle className="w-5 h-5" />,
  AlertCircle: <AlertCircle className="w-5 h-5" />,
  Building2: <Building2 className="w-5 h-5" />,
  Wrench: <Wrench className="w-5 h-5" />,
  Search: <Search className="w-5 h-5" />,
  CheckCircle2: <CheckCircle2 className="w-5 h-5" />,
};

export const KPICard: React.FC<KPICardProps> = ({ metric, className }) => {
  const trendIcon = metric.trendDirection === 'up' ? (
    <TrendingUp className="w-3.5 h-3.5" />
  ) : metric.trendDirection === 'down' ? (
    <TrendingDown className="w-3.5 h-3.5" />
  ) : (
    <Minus className="w-3.5 h-3.5" />
  );

  const trendColor = metric.trendDirection === 'up'
    ? 'text-emerald-400'
    : metric.trendDirection === 'down'
    ? 'text-rose-400'
    : 'text-slate-400';

  const iconNode = metric.icon ? ICON_MAP[metric.icon] : null;

  return (
    <div className={clsx('bg-slate-800 border border-slate-700/60 rounded-xl p-5', className)}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-medium text-slate-400">{metric.label}</p>
          <p className="text-2xl font-semibold text-slate-100 mt-1">{metric.value}</p>
          {metric.trend && (
            <div className={clsx('flex items-center gap-1 mt-2 text-xs font-medium', trendColor)}>
              {trendIcon}
              <span className="truncate">{metric.trend}</span>
            </div>
          )}
        </div>
        {iconNode && (
          <div className="p-2.5 bg-sky-500/10 text-sky-400 rounded-xl flex-shrink-0">
            {iconNode}
          </div>
        )}
      </div>
    </div>
  );
};
